module.exports = __webpack_public_path__ + "img/s4_v1.3b5e4cfd.png";